module.exports = __webpack_public_path__ + "img/location.f25613e1.svg";